import { useEffect, useId, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  FaBullseye,
  FaChartLine,
  FaDollarSign,
  FaStar,
  FaUsers,
} from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import { Button } from "../../Components/CustomComponents";
import CustomTabs from "../UserManagement/Components/CustomTabs";
import Header from "../UserManagement/Components/Header";
import TabContent from "../UserManagement/Components/TabContent";
import AccessPlansTab from "./Components/AccessPlansTab";
import BrokerMetricsTab from "./Components/BrokerMetricsTab";
import EscrowCommissionTab from "./Components/EscrowCommissionTab";
import ForecastingTab from "./Components/ForecastingTab";
import KPICard from "./Components/KPICard";
import RevenueMixTab from "./Components/RevenueMisTab";
import styles from "./styles/user_management.module.scss";
import KPICardSkeleton from "../../Components/Skeleton/KPICardSkeleton";

const dashboardKPIs = [
  { id: 1, title: "Total Revenue", value: "$410,000", trend: "+8.2%" },
  { id: 2, title: "Total Transactions", value: "462", trend: "+12.1%" },
  { id: 3, title: "Avg Commission", value: "$2,500", trend: "+5.3%" },
  { id: 4, title: "Platform Revenue", value: "$82,000", trend: "+15.7%" },
  { id: 5, title: "Current LTV", value: "$4,892", trend: "+7.9%" },
];

const cardConfig = {
  1: {
    icon: <FaDollarSign size={24} />,
    // bgColor: "bg-success bg-opacity-10",
    iconColor: "text-success",
  },
  2: {
    icon: <FaUsers size={24} />,
    // bgColor: "bg-primary bg-opacity-10",
    iconColor: "text-primary",
  },
  3: {
    icon: <FaBullseye size={24} />,
    // bgColor: "bg-purple bg-opacity-10",
    iconColor: "text-purple",
  },
  4: {
    icon: <FaChartLine size={24} />,
    // bgColor: "bg-warning bg-opacity-10",
    iconColor: "text-warning",
  },
  5: {
    icon: <FaStar size={24} />,
    // bgColor: "bg-danger bg-opacity-10",
    iconColor: "text-danger",
  },
};

const forecastingKPIs = [
  {
    id: 1,
    title: "Monthly Recurring Revenue",
    value: "$148K",
  },
  {
    id: 2,
    title: "Annual Recurring Revenue",
    value: "$1770K",
  },
  {
    id: 3,
    title: "LTV/CAC Ratio",
    value: "19.6:1",
  },
  {
    id: 4,
    title: "Close Rate",
    value: "15%",
  },
];

const FinanceManagementScreen = () => {
  const uniqueId = useId();
  const [activeKey, setActiveKey] = useState("revenue_mix");

  const tabs = [
    { key: "revenue_mix", label: "Revenue Mix" },
    {
      key: "forecasting",
      label: "Forecasting",
    },
    { key: "escrow_commission", label: "Escrow & Commission" },
    { key: "access_plans", label: "Access Plans" },
    { key: "broker_metrics", label: "Broker Metrics" },
  ];

  const content = (key) => {
    switch (key) {
      case "revenue_mix":
        return <RevenueMixTab />;
      case "forecasting":
        return <ForecastingTab forecastingKPIs={forecastingKPIs} />;
      case "escrow_commission":
        return <EscrowCommissionTab />;
      case "access_plans":
        return <AccessPlansTab />;
      case "broker_metrics":
        return <BrokerMetricsTab />;
      default:
        return null;
    }
  };

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  return (
    <div className={styles.MainContainer}>
      <div
        className={`${styles.headerContainer} d-flex flex-wrap gap-3 justify-content-between align-items-center`}
      >
        <div>
          <Header
            title={"Financials"}
            subTitle={"Product revenue, platform fees, and commission tracking"}
          />
        </div>

        <Button
          style={{ width: "280px" }}
          classes={`${styles.cardBtn} text-center px-3`}
          text={
            <span className="gap-2 d-flex align-items-center">
              <FaDownload />
              Export to QuickBooks
            </span>
          }
          onClick={() => {}}
        ></Button>
      </div>
      <main>
        <br />
        <div className="d-flex flex-wrap gap-3">
          {dummyFetch.isFetching
            ? Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={uniqueId}
                  style={{
                    flex: "1 1 200px",
                    // maxWidth: "300px"
                  }}
                >
                  <KPICardSkeleton />
                </div>
              ))
            : dashboardKPIs.map((data) => (
                <div
                  key={uniqueId}
                  style={{
                    flex: "1 1 200px",
                    // maxWidth: "300px"
                  }}
                >
                  <KPICard kpiData={data} cardConfig={cardConfig[data.id]} />
                </div>
              ))}
        </div>
        <br />
        {/* TABS */}
        <CustomTabs
          tabs={tabs}
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(key)}
        />
        {/* TAB CONTENT */}
        <div className="h-100 w-100">
          <TabContent activeKey={activeKey} content={content} />
        </div>
      </main>
    </div>
  );
};

export default FinanceManagementScreen;
